import type { DesktopBridge } from "./types";
import { openExternalBrowserWindow } from "./external";

const desktopOnly = async (): Promise<never> => {
  throw new Error("This capability is available in the Tauri desktop application.");
};

export const browserBridge: DesktopBridge = {
  isDesktop: false,
  authSession: {
    load: desktopOnly,
    store: desktopOnly,
  },
  selectWorkspaceRoot: async () => null,
  revokeWorkspaceRoot: desktopOnly,
  listDirectory: desktopOnly,
  readTextFile: desktopOnly,
  applyTextPatch: desktopOnly,
  readFileBytes: desktopOnly,
  writeFileBytes: desktopOnly,
  fileSearch: {
    search: desktopOnly,
  },
  git: {
    status: desktopOnly,
    diff: desktopOnly,
  },
  github: {
    listPullRequests: desktopOnly,
    getPullRequest: desktopOnly,
    diffPullRequest: desktopOnly,
  },
  terminal: {
    list: desktopOnly,
    attach: desktopOnly,
    spawn: desktopOnly,
    write: desktopOnly,
    resize: desktopOnly,
    kill: desktopOnly,
    onEvent: async () => () => undefined,
  },
  openExternal: (url) => openExternalBrowserWindow(window.open.bind(window), url),
  sshFiles: {
    discoverHosts: desktopOnly,
    connect: desktopOnly,
    listDirectory: desktopOnly,
    readTextFile: desktopOnly,
    close: desktopOnly,
  },
};
